import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../../shared/types/analytics';

export const trackPublishWithVisibleViolationsConfirmClose = (
  product: object,
  action: string,
  offerStatus: TAnalyticsOfferStatus,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action,
    label: 'violation_found_popup',
    products: [product],
  });
};
